import React, { useState } from 'react';

interface LinkInputProps {
  onSubmit?: (link: string) => void;
}

const LinkInput: React.FC<LinkInputProps> = ({ onSubmit }) => {
  const [link, setLink] = useState('');

  const handleSubmit = () => {
    if (link && onSubmit) {
      onSubmit(link);
      setLink('');
    }
  };

  return (
    <div className="input-group mb-3">
      <input
        className="form-control"
        placeholder="Digite o link"
        type="text"
        value={link}
        onChange={(e) => setLink(e.target.value)}
      />
      {!!onSubmit && (
        <button className="btn btn-primary" disabled={!link} type="button" onClick={handleSubmit}>
          Enviar
        </button>
      )}
    </div>
  );
};

export default LinkInput;
